module.exports = __webpack_public_path__ + "media/home.093806c3.mp4";